import { Dispatch } from "redux";
import ApiUrls from "../../../constants/ApiUrls";
import MiddlewareEntities from "../../../constants/MiddlewareEntities";
import TransactionStatuses, { SHOW_P2P_MODAL_KEY } from "../../../constants/TransactionStatuses";
import { TransactionFactory } from "../../../factories/checkout/transaction/TransactionFactory";
import UrlService from "../../../services/UrlService";
import { apiRequest } from "../api/actions";
import { setLoader } from "../ui/actions";
import { setTransaction, updateTransactionStatus } from "./actions";

abstract class ITransactionMiddlewareProxy {

  public static fetchTransactionWithHash: (next: Dispatch, action: any) => void;
  public static fetchTransactionWithSaid: (next: Dispatch, action: any) => void;
  public static transactionAPISuccess: (next: Dispatch, payload: any) => void;
  public static transactionAPIError: (next: Dispatch) => void;
  public static cancelTransaction: (next: Dispatch, payload: any) => void;
  public static cancelTransactionAPISuccess: (next: Dispatch) => void;
  public static cancelTransactionAPIError: (next: Dispatch) => void;

}

export default class TransactionMiddlewareProxy extends ITransactionMiddlewareProxy {

  public static fetchTransactionWithHash(next: Dispatch, action: any): void {
    next(apiRequest(
      null,
      "GET",
      `${ApiUrls.FETCH_TRANSACTION}/${action.params.secret}`,
      null,
      null,
      MiddlewareEntities.TRANSACTION,
      {}
    ));
    next(setLoader(true, MiddlewareEntities.TRANSACTION));
  }

  public static fetchTransactionWithSaid(next: Dispatch, action: any): void {
    next(apiRequest(
      null,
      "GET",
      `${ApiUrls.FETCH_TRANSACTION}`,
      { said: action.params.said },
      null,
      MiddlewareEntities.TRANSACTION,
      {}
    ));
    next(setLoader(true, MiddlewareEntities.TRANSACTION));
  }

  public static transactionAPISuccess(next: Dispatch, payload: any): void {
    const currentTime = new Date().getTime() / 1000;
    const { FINISHED, ORDER_APPROVED, ORDER_CONFIRMATION, WORK_ORDER_READY } = TransactionStatuses;
    const validTransactionStatuses = [FINISHED, ORDER_APPROVED, ORDER_CONFIRMATION, WORK_ORDER_READY];
    next(setTransaction(TransactionFactory.create(payload.data)));
    next(setLoader(false, MiddlewareEntities.TRANSACTION));

    if (payload.data.onlyPosition || validTransactionStatuses.includes(payload.data.details.order?.status)) {
      const said = UrlService.getUrlParameter(window.location.href, "said");
      const timer = 60000;
      const timerId: NodeJS.Timer = setTimeout(() => {
        if (new Date().getTime() / 1000 - currentTime > 3600) {
          clearTimeout(timerId);
          return;
        }

        const apiUrlExtension = said ? `?said=${said}` : `/${payload.data.details.order?.secret}`;
        next(apiRequest(
          null,
          "GET",
          `${ApiUrls.FETCH_TRANSACTION}${apiUrlExtension}`,
          null,
          null,
          MiddlewareEntities.TRANSACTION,
          {}
        )
        );
      }, timer);
    }
  }

  public static transactionAPIError(next: Dispatch): void {
    next(setLoader(false, MiddlewareEntities.TRANSACTION));
    next(updateTransactionStatus(TransactionStatuses.FAILED));
  }

  public static cancelTransaction(next: Dispatch, payload: any): void {
    const { secret, data } = payload;
    next(apiRequest(
      null,
      "POST",
      `${ApiUrls.CANCEL_TRANSACTION}/${secret}`,
      null,
      data,
      MiddlewareEntities.CANCEL_TRANSACTION,
      {}
    )
    );
    next(setLoader(true, MiddlewareEntities.CANCEL_TRANSACTION));
  }

  public static cancelTransactionAPISuccess(next: Dispatch): void {
    window.location.reload();
    next(setLoader(false, MiddlewareEntities.CANCEL_TRANSACTION));
  }

  public static cancelTransactionAPIError(next: Dispatch): void {
    next(setLoader(false, MiddlewareEntities.CANCEL_TRANSACTION));
    next(updateTransactionStatus(TransactionStatuses.FAILED));
  }

  public static cancelPre2PostTransaction(next: Dispatch, payload: any): void {
    const { secret, data } = payload;
    next(apiRequest(
      null,
      "POST",
      `${ApiUrls.CANCEL_TRANSACTION}/${secret}`,
      null,
      data,
      MiddlewareEntities.CANCEL_P2P_TRANSACTION,
      {}
    )
    );
    next(setLoader(true, MiddlewareEntities.CANCEL_P2P_TRANSACTION));
  }

  public static cancelPre2PostTransactionAPISuccess(next: Dispatch): void {
    sessionStorage.setItem(SHOW_P2P_MODAL_KEY, 'true');
    window.location.reload();
    next(setLoader(false, MiddlewareEntities.CANCEL_P2P_TRANSACTION));
  }

  public static cancelPre2PostTransactionAPIError(next: Dispatch): void {
    next(setLoader(false, MiddlewareEntities.CANCEL_TRANSACTION));
    next(updateTransactionStatus(TransactionStatuses.FAILED));
  }


}
